import { render, staticRenderFns } from "./KeyboardSvgWrapper.vue?vue&type=template&id=80cfe758&scoped=true&"
import script from "./KeyboardSvgWrapper.vue?vue&type=script&lang=js&"
export * from "./KeyboardSvgWrapper.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardSvgWrapper.vue?vue&type=style&index=0&id=80cfe758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cfe758",
  null
  
)

export default component.exports